export * from './GiftCardConfirmationLoadingPlaceholder';
